import {Container, Grid, Header, List, Segment} from "semantic-ui-react";
import React, { Component } from 'react'
import {Translate} from "react-localize-redux";

class Footer extends Component {
  render() {
    return (
      <Segment inverted vertical style={{padding: '5em 0em', position: '0px'}}>
        <Container>
          <Grid divided='vertically' inverted verticalAlign='middle' style={{padding: '0em 10em'}}>
            <Grid.Row/>
          </Grid>
          <Grid divided inverted stackable >
            <Grid.Row centered>
              <Grid.Column width={3}>
                <List link inverted>
                  <List.Item as='a' href="https://morrisoncole.co.uk/"><Translate id='footer.creator'/></List.Item>
                </List>
              </Grid.Column>
              <Grid.Column width={7}>
                <Header as='h4' inverted>
                  <Translate id="latentSignal" /> &copy; 2018
                </Header>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Container>
      </Segment>
    )
  }
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/footer/Footer.js